/* eslint-disable @nx/enforce-module-boundaries */
import { forwardRef } from 'react';
import { MyNetworkMyCircle } from './first';
const MyNetworkCircle = forwardRef(({ ...props }, ref) => {
  return <MyNetworkMyCircle />;
});
export default MyNetworkCircle;
